import React from "react";

import incomingIcon from "../images/incoming-icon.png";

export default function CheckWithDateRevoked(props) {
  return (
    <div
      className="container-check-with-name"
      title={`Revoked by: ${props.title}`}
      style={{ cursor: "pointer" }}
    >
      {props.checked === true ? (
        // <img alt=""
        //   style={{
        //     width: "24px",
        //     height: "24px",
        //   }}
        //   src={CheckGreen}
        // />
        <span style={{ color: "green", fontWeight: "600", fontSize: "12px" }}>
          Revoked
        </span>
      ) : props.checked === false ? (
        // <img alt=""
        //   style={{
        //     width: "24px",
        //     height: "24px",
        //   }}
        //   src={CancelIcon}
        // />
        <span style={{ color: "red", fontWeight: "500", fontSize: "12px" }}>
          Not Revoked
        </span>
      ) : (
        <img alt=""
          style={{
            width: "24px",
            height: "24px",
          }}
          src={incomingIcon}
        />
      )}

      {props.content !== 0 ? (
        <div className="name-for-check">({props.content}) </div>
      ) : (
        ""
      )}
      {/* <div className="name-for-check">({props.content}) </div> */}
    </div>
  );
}
